export const SET_ALL_OPERATORS = 'SET_ALL_OPERATORS'
export const ADD_NEW_OPERATOR = 'ADD_NEW_OPERATOR'
export const DELETE_OPERATOR = 'DELETE_OPERATOR'
export const UPDATE_EXISTING_OPERATOR = 'UPDATE_EXISTING_OPERATOR'
